<template>
  <templateAdminComponent v-if="isUserAuthenticated()">
    <div v-if="isUserAuthenticated()">
      <v-toolbar flat color="white">
        <v-toolbar-title>Dépôts</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px" no-click-animation persistent>
          <v-btn slot="activator" color="primary" dark class="mb-2" @click="createItem()">Nouveau dépôt</v-btn>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.ID" label="Numéro du dépôt" disabled hide-details></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-menu
                      :close-on-content-click="false"
                      v-model="menu"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="editedItem.Date"
                        label="Date"
                        persistent-hint
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker v-model="date" no-title @input="saveDate(editedItem, date)"></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-checkbox v-model="editedItem.IsActive" label="Est actif"></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click.native="close">Annuler</v-btn>
              <v-btn color="blue darken-1" flat @click.native="save">Sauvegarder</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="items"
          :pagination.sync="pagination"
          hide-actions
          class="elevation-1"
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : '',
                  header.align ? 'text-xs-' + header.align : ''
                ]"
                :width="header.width"
                @click="changeSort(header.value)"
              >
                <v-icon small>arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ props.item.ID }}</td>
            <td class="text-xs-left">{{ props.item.Date | formatDate }}</td>
            <td class="justify-center layout px-0">
              <v-icon medium class="mr-2" @click="editItem(props.item)">edit</v-icon>
              <v-tooltip bottom>
                <v-icon slot="activator" medium style="height:100%;" @click="generateBankReport(props.item)">payment</v-icon>
                <span>Rapport des chèques de banque</span>
              </v-tooltip>
              <!--
                assessment

                massif:
                add_to_photos
              -->
              <!-- <v-icon small @click="deleteItem(props.item)">delete</v-icon> -->
            </td>
          </template>
          <template slot="no-data">
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
          <!-- <v-pagination v-model="pagination.page" :length="pages"></v-pagination> -->
          <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
        </div>
      </v-card>
    </div>
  </templateAdminComponent>
</template>

<script>
import moment from 'moment'
import auth from '@/auth'
import TemplateAdminComponent from '@/components/TemplateAdmin.vue'
import APIDeposit from '@/api/deposit'
import APIReport from '@/api/report'
const APIService = new APIDeposit();
const APIReportService = new APIReport();

var axios = require('axios')

export default {
  components:
  {
    TemplateAdminComponent
  },
  data() {
    return {
        date: null,
        menu: false,
        modal: false,

        dialog: false,
        loading: false,
        pagination: {
          sortBy: 'Name',
          page: 1,
          rowsPerPage: 10
        },
        headers : [
          { text: 'Numéro', value: 'ID', align: 'left' },
          { text: 'Date', value: 'Date', align: 'left' },
          { text: 'Actions', value: 'Actions', align: 'center', sortable: false }
        ],
        items: [],
        editedIndex: -1,
        editedItem: {},
        defaultItem: {
          Date: moment().format("YYYY-MM-DD"),
          IsCustomerEventSent: true,
          IsActive: true
        }
    }
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nouvel événement' : 'Modification de l\'événement'
    },

    pages() {
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null)
        return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    items() {
      this.$nextTick(() => {
        this.pagination.totalItems = this.items.length
      })
    }
  },

  created(){
    this.initialize()
  },

  methods: {
    isUserAuthenticated() {
      return auth.isUserAuthenticated()
    },

    logout() {
      auth.logout()
    },

    initialize() {
      var events = APIService.getAll().then(response =>  {
            this.items = response.data
        }
      )

    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },

    createItem() {
      //debugger;
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.date = moment().format("YYYY-MM-DD")
      this.dialog = true
    },

    editItem(item) {
      //debugger;
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.Date = moment(this.editedItem.Date).format("YYYY-MM-DD")
      this.date = moment(this.editedItem.Date).format("YYYY-MM-DD")
      this.dialog = true
    },

    async generateBankReport(item) {
      await APIReportService.generateBankExcel(item.ID).then(response =>  {})
    },

    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save() {
      if (this.editedIndex > -1) {
        //UPDATE
        APIService.update(this.editedItem).then(response => {
          //debugger;
          if(response.data)
          {
            if (this.editedItem.IsActive)
            {
              Object.assign(this.items[this.editedIndex], this.editedItem)
            }
            else
            {
              this.items.splice(this.editedIndex, 1)
            }
          }
          this.close()
        })
      } else {
        //CREATE
        APIService.create(this.editedItem).then(response => {
          //debugger;
          if(response.data)
            this.items.unshift(response.data)

          this.close()
        })
      }
    },

    saveDate(item, date) {
      //alert(date)
      //item.Date = date
      if (this.date != null)
      {
        item.Date = moment(date).format('YYYY-MM-DD')
        this.menu = false

      }
      this.dialog = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/Depots.vue